export default "__VITE_ASSET__8304d286__"